import React from 'react';
import { cn } from '../../utils/cn';

const SRC = {
  upper: '/photo-guides/occlusionSup.webp',
  lower: '/photo-guides/occlusionInf.webp',
};

const ALT = {
  upper: 'Exemple de vue occlusale — arcade supérieure (maxillaire)',
  lower: 'Exemple de vue occlusale — arcade inférieure (mandibulaire)',
};

/**
 * Repères visuels pour l’import STL : photos guides occlusales (même ressource que les photos cliniques).
 */
const StlArchIcon = ({ variant, className = '' }) => {
  if (variant !== 'upper' && variant !== 'lower') return null;
  return (
    <img
      src={SRC[variant]}
      alt={ALT[variant]}
      loading="lazy"
      decoding="async"
      className={cn(
        'h-auto max-h-40 w-full max-w-[260px] object-contain rounded-lg border border-border bg-card shadow-sm',
        className
      )}
    />
  );
};

export default StlArchIcon;
